import { Component, Input, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MenuService } from './app.menu.service';
import { AppMainComponent } from 'src/app/app.main.component';

@Component({
    /* tslint:disable:component-selector */
    selector: '[app-menuitem]',
    /* tslint:enable:component-selector */
    templateUrl: './app.menuitem.component.html',
    animations: [
        trigger('children', [
            state('void', style({
                height: '0px'
            })),
            state('hiddenAnimated', style({
                height: '0px'
            })),
            state('visibleAnimated', style({
                height: '*'
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('void => visibleAnimated, visibleAnimated => void', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ],
    standalone: false
})
export class AppMenuitemComponent implements OnInit, OnDestroy {

    @Input() item: any;
    @Input() index: number;
    @Input() root: boolean;
    @Input() parentKey: string;
    active = false;
    menuSourceSubscription: Subscription;
    menuResetSubscription: Subscription;
    key: string;

    constructor(public appMain: AppMainComponent, public router: Router, private cd: ChangeDetectorRef, private menuService: MenuService) {
        this.menuSourceSubscription = this.menuService.menuSource$.subscribe(key => {
            if (this.active && this.key !== key && key.indexOf(this.key) !== 0) {
                this.active = false;
            }
        });

        this.menuResetSubscription = this.menuService.resetSource$.subscribe(() => {
            this.active = false;
        });

        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                if (this.item.routerLink || this.item.items) {
                    this.updateActiveStateFromRoute();
                } else {
                    this.active = false;
                }
            });
    }

    ngOnInit() {
        if (this.item.routerLink || this.item.items) {
            this.updateActiveStateFromRoute();
        }
        this.key = this.parentKey ? this.parentKey + '-' + this.index : String(this.index);
    }

    updateActiveStateFromRoute() {
        // Un item de grupo (con submenú, p.ej. "Configuración") no tiene
        // routerLink propio: sólo se calcula si está activo mirando si
        // alguno de sus hijos coincide con la ruta actual, más abajo.
        this.active = this.item.routerLink
            ? this.router.isActive(this.item.routerLink[0], !this.item.items)
            : false;
        if (!this.active) {
            let urlPart = `/${this.router.url.split("/")[1]}`;
            if (!this.item.items && this.item.routerLink && urlPart == this.item.routerLink[0]
                && this.item.routerLink[0] != "/") {
                this.active = true;
            } else if (this.item.items && this.item.items.findIndex(x => x.routerLink && x.routerLink[0] != "/"
                && urlPart.indexOf(x.routerLink[0]) !== -1) >= 0) {
                this.active = true;
            }
        }
    }

    itemClick(event: Event) {
        if (this.item.disabled) {
            event.preventDefault();
            return true;
        }

        this.menuService.onMenuStateChange(this.key);

        if (this.item.command) {
            this.item.command({ originalEvent: event, item: this.item });
        }

        if (this.item.items) {
            this.active = !this.active;
        } else {
            this.active = true;
            if (this.appMain.isMobile()) {
                this.appMain.mobileMenuOpen = false;
            }
        }
    }

    ngOnDestroy() {
        if (this.menuSourceSubscription) {
            this.menuSourceSubscription.unsubscribe();
        }
        if (this.menuResetSubscription) {
            this.menuResetSubscription.unsubscribe();
        }
    }
}

